<template>
  <div class="ReusableModal">
    <v-row justify="center">
      <v-dialog
        v-model="openDialogModel"
        @keydown.esc="onEmitEvent"
        scrollable
        persistent
        :max-width="modalWidth ? modalWidth : '34%'"
        :width="minModalWidth"
        :content-class="showClassName ? 'treeSelect' : ''"
      >
        <v-card>
          <v-card-title class="d-flex justify-space-between card-header">
            <span class="blue-text headerTitle">
              <slot name="header"></slot
            ></span>
            <span @click="onEmitEvent">
              <v-icon class="fs-21px cursor-pointer">close</v-icon>
            </span>
          </v-card-title>
          <v-card-text
            class="card-body"
            :class="isUserModal ? 'userModalHeight' : ''"
          >
            <!-- <main> -->
            <slot name="main"></slot>
            <!-- </main> -->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <slot name="subFoot"></slot>
            <slot name="footer"></slot>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "ReuseModal",
  props: {
    openDialog: Boolean,
    modalHeader: String,
    isDisableBtn: Boolean,
    modalWidth: String,
    showSubFooter: Boolean,
    showMainFooter: Boolean,
    isUserModal: Boolean,
    loadingBtn: Boolean,
    minModalWidth: String,
    showClassName: Boolean,
  },
  data: () => {
    return {
      dialogModal: false,
      modalHeader1: "",
    };
  },
  computed: {
    openDialogModel() {
      return this.openDialog;
    },
    modalHeader2() {
      return this.modalHeader;
    },
    disableBtn() {
      return this.isDisableBtn;
    },
  },
  mounted() {
    // console.log(this.isDisableBtn, this.disableBtn);
  },
  methods: {
    onEmitEvent() {
      this.$emit("emitModalEvent", false);
    },
    toggleCloseModal(data) {
      this.openDialog = data;
    },
  },
};
</script>
<style scoped>
.userModalHeight {
  height: calc(100vh - 350px);
}
.headerTitle {
  font-size: 18px !important;
  font-weight: bold !important;
}
</style>
